const DIAL_PAD_KEYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '*',
  '0',
  '#',
];

export const DialPad = ({ onClick }) => {
  return (
    <div className="grid grid-cols-3 grid-rows-4 gap-3">
      {DIAL_PAD_KEYS.map(v => (
        <button
          key={v}
          onClick={() => {
            onClick(v);
          }}
          className="rounded-[20px] w-[72px] h-16 bg-base-200 text-brand-900 font-medium text-[24px]/[36px]"
        >
          {v}
        </button>
      ))}
    </div>
  );
};
